export enum TagScreenConstants {
  GET_SCREEN_TAGS_BY_TYPE_SUCCESS = 'TagScreenConstants_GET_SCREEN_TAGS_BY_TYPE_SUCCESS',
  CLEAR = 'TagScreenConstants_CLEAR',
  ERROR = 'TagScreenConstants_ERROR'
}
